import React, { useState } from "react";
import { GlassCard } from "../components/GlassCard";

export const ProjectsPage = ({ c, isDark }) => {
  const [filter, setFilter] = useState("All");
  const bgDot = isDark
    ? "radial-gradient(rgba(255,255,255,0.04) 1px, transparent 1px)"
    : "radial-gradient(rgba(0,0,50,0.06) 1px, transparent 1px)";

  const filters = ["All", "Full-Stack", "Backend", "Frontend"];

  const projects = [
    {
      title: "Neural_Stream v2.0",
      tags: ["NEXT.JS", "TYPESCRIPT", "REDIS"],
      category: "Full-Stack",
      desc: ["Reduced API latency by 45% via custom caching.", "Real-time WebSocket synchronization for 10k concurrent."],
      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuCtWDe1BpfkL9FpAqKh1KjbYRW1Pcvc1PJLyHbPogcZh7CU-3lfLJqrpfPea4g7RxZlVPNRlKSQqiTGmuBRAx_VAzGzBdsuUvai0mytMDWaTIovV4a06RDSm_1f4W6sb1c3NXxzqUUefg4HFtY6EL6XEcbgLMkaF1g5BDgrnGGJOrM2QUc0qM03yDSqQhVn7gUDdVG9tI_dGR2kiCsuSkBjZ4qgnHYPWoWWS_alHG6vRfVf88_-GtNqm_kAjE3VH-8oDBnbIiBNSqg",
    },
    {
      title: "Vault_Core",
      tags: ["GO", "KUBERNETES", "GRPC"],
      category: "Backend",
      desc: ["Microservices mesh handling 1.2M req/sec.", "Zero-downtime rolling deployment logic."],
      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBC16TkCxeT-dlGUfrNVI_us-s7-yEg2B26EUdYLLCn3gbCOLdGvCu_TRdCzH7IqvJfpDPBP5Gy5tdrBCRuxkGVDQcRiLJA_cN4Z9Ir8qywi9EPtefKHH-w9qJFKdiw7NZkt6KSudI41SLgYkZku6qXqNeqN5JTG2hzOCBHlhgC-8qGdS9CYF_Xk968V58tjNn_Rim-FDyNUoypa7pOta9a7VvGpZsSanNW8f0MDcR7N6Lm2dqTmCyo6f_rQECtNDjoiXZGIyw8z-g",
    },
    {
      title: "Prism_UI_Kit",
      tags: ["REACT", "STORYBOOK", "TAILWIND"],
      category: "Frontend",
      desc: ["Full WCAG 2.1 accessibility compliance.", "Dynamic theming engine with CSS variables."],
      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBnA-to8TijDHaD6iZ8cCLPN8ETcfrzl4KvLVIvdnAwTe_L7b2ED1lyzKDHJkQ8qoLPRvkt6cmgqZsIDe1hhwxUfdDx4vyv-kG1lhEXf5gRx1Desw1zu-smGgQ_qbGzURMDSo_yNMwYU1W_DvZ64L03newQ6TQtwJIhh-_X45kwUL0Jj9qf1Fr9ooBsaHrUmgD4A4rQ9iydbDfuir-n97wKIHt-kkAlsP4tNSBAivH9xgjKGU3YVRZXl_OFLNjwW8PX-vNgNJGLOKo",
    },
    {
      title: "Code_Craft CLI",
      tags: ["PYTHON", "DOCKER"],
      category: "Backend",
      desc: ["Automated 20+ CI/CD boilerplate steps."],
      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBteuKltbpvcViJZvQYnUmoENoYOzgo0sLODAY3Yyfwrr-Bs5OVSjnHmrsiPls7HOleFbvSQg-sjfCrCpbaB_OJWiAPS6bqmLn3nUZGhJM2IjCspiZglxQgNbXPkIiQ_ktzRAdldis4SIE2Hnga7J6SKY6V30IERuVtFMZx_5Gb7CRcT2z4Odp6AgsO7HRSJAoaFUYLpv9ZYaH0qYjPkSzonynWxstpCcZb7q1jv0bUChrk5lS5SrkRhYF308fX9AJKPVdNQtDhgrc",
    },
  ];

  const featured = {
    title: "OmniScale Cluster",
    tags: ["RUST", "DOCKER", "AWS_SDK"],
    badge: "ACTIVE_PRODUCTION",
    desc: "A proprietary distributed database engine designed for low-latency writes across global clusters. Features automatic sharding and conflict resolution strategies for high-traffic enterprise environments.",
    img: "https://lh3.googleusercontent.com/aida-public/AB6AXuCBHTGBT_7CPaoVUePCB26jIuIlrDuoREp5WW3jUZuFN7aWQwa4unzQTbV3TZWwtIRjBEk_d1qZWeJlgeKaJUzhmjz4mTLhcOkKjbEQoEvoq4yLI3TX_j-ihlFdmSSEMIrJVYE1x8o5m9sIwTvVR-sxC_EJxBiloc8RNkN-rIosI_5EHizV0b85xXSw3cmfDPMzdVQTFyyVUaj5tY83563CNYTwvuLk_FkeGIZrr-HRkSbWZzEmtVLsigunjfbcn0YMVmWG68U-mns",
  };

  const filtered = projects.filter(p => filter === "All" || p.category === filter);

  return (
    <div style={{ background: c.background, minHeight: "100vh", backgroundImage: bgDot, backgroundSize: "32px 32px", paddingTop: 120 }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "48px 64px 120px" }}>
        <header style={{ marginBottom: 48 }}>
          <div style={{ display: "inline-flex", padding: "4px 12px", marginBottom: 16, borderRadius: 9999, background: `${c.primary}18`, border: `1px solid ${c.primary}30` }}>
            <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.primary, letterSpacing: "0.2em", textTransform: "uppercase" }}>Repository</span>
          </div>
          <h1 style={{ fontFamily: "'Geist', sans-serif", fontWeight: 700, fontSize: "clamp(36px,5vw,64px)", color: c.onSurface, letterSpacing: "-0.02em", lineHeight: 1.1, marginBottom: 16 }}>
            Engineered Solutions
          </h1>
          <p style={{ fontFamily: "'Geist', sans-serif", fontSize: 18, color: c.onSurfaceVariant, maxWidth: 560, lineHeight: 1.6 }}>
            A curated selection of high-impact projects. Each is a study in technical depth, scalability, and refined product thinking.
          </p>
        </header>

        <div style={{ display: "flex", gap: 16, marginBottom: 48, flexWrap: "wrap" }}>
          {filters.map(f => (
            <button key={f} onClick={() => setFilter(f)} style={{
              padding: "8px 24px", borderRadius: 9999, cursor: "pointer",
              fontFamily: "'JetBrains Mono', monospace", fontSize: 12, fontWeight: 700,
              transition: "all 0.3s",
              background: filter === f ? c.primary : "transparent",
              color: filter === f ? c.onPrimaryContainer : c.onSurfaceVariant,
              border: filter === f ? "none" : `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
              boxShadow: filter === f ? `0 0 20px ${c.primary}50` : "none",
            }}>{f}</button>
          ))}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 32, marginBottom: 32 }}>
          {filtered.map((p) => (
            <GlassCard key={p.title} isDark={isDark} style={{ borderRadius: 16, overflow: "hidden", cursor: "pointer", transition: "all 0.5s" }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-8px)"; e.currentTarget.style.borderColor = `${c.primary}60`; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.borderColor = isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)"; }}
            >
              <div style={{ position: "relative", height: 200, overflow: "hidden" }}>
                <img src={p.img} alt={p.title} style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.7s" }}
                  onMouseEnter={e => e.target.style.transform = "scale(1.1)"}
                  onMouseLeave={e => e.target.style.transform = "scale(1)"}
                />
                <div style={{ position: "absolute", inset: 0, background: `linear-gradient(to top, ${c.background}cc, transparent)`, opacity: 0.6 }} />
              </div>
              <div style={{ padding: 32 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
                  <h3 style={{ fontFamily: "'Geist', sans-serif", fontSize: 20, fontWeight: 600, color: c.onSurface }}>{p.title}</h3>
                  <div style={{ display: "flex", gap: 8 }}>
                    {["terminal", "open_in_new"].map(icon => (
                      <span key={icon} className="material-symbols-outlined" style={{ fontSize: 20, color: c.onSurfaceVariant, cursor: "pointer", transition: "color 0.2s" }}
                        onMouseEnter={e => e.target.style.color = "#fff"}
                        onMouseLeave={e => e.target.style.color = c.onSurfaceVariant}
                      >{icon}</span>
                    ))}
                  </div>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 24 }}>
                  {p.tags.map(t => (
                    <span key={t} style={{
                      fontFamily: "'JetBrains Mono', monospace", fontSize: 10, padding: "3px 8px",
                      borderRadius: 4, background: c.surfaceVariant, color: c.primary, border: `1px solid ${c.primary}30`,
                    }}>{t}</span>
                  ))}
                </div>
                <ul style={{ marginBottom: 24 }}>
                  {p.desc.map(d => (
                    <li key={d} style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 12 }}>
                      <span className="material-symbols-outlined" style={{ fontSize: 18, color: c.primary, marginTop: 1 }}>check_circle</span>
                      <span style={{ fontFamily: "'Geist', sans-serif", fontSize: 15, color: c.onSurfaceVariant, lineHeight: 1.5 }}>{d}</span>
                    </li>
                  ))}
                </ul>
                <div style={{ paddingTop: 24, borderTop: `1px solid ${isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}` }}>
                  <button style={{
                    width: "100%", padding: "12px 0", borderRadius: 8, cursor: "pointer",
                    background: "transparent",
                    border: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
                    fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.onSurface,
                    transition: "all 0.2s",
                  }}
                    onMouseEnter={e => { e.target.style.background = c.primary; e.target.style.color = c.onPrimaryContainer; }}
                    onMouseLeave={e => { e.target.style.background = "transparent"; e.target.style.color = c.onSurface; }}
                  >VIEW_ARCHITECTURE</button>
                </div>
              </div>
            </GlassCard>
          ))}
        </div>

        <GlassCard isDark={isDark} style={{ borderRadius: 16, overflow: "hidden", cursor: "pointer", transition: "all 0.5s" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div style={{ position: "relative", overflow: "hidden", minHeight: 300 }}>
              <img src={featured.img} alt={featured.title} style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.7s" }}
                onMouseEnter={e => e.target.style.transform = "scale(1.05)"}
                onMouseLeave={e => e.target.style.transform = "scale(1)"}
              />
              <div style={{ position: "absolute", inset: 0, background: `linear-gradient(to right, ${c.background}70, transparent)` }} />
            </div>
            <div style={{ padding: 48, display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: c.secondary, boxShadow: `0 0 10px ${c.secondary}` }} />
                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.secondary }}>ACTIVE_PRODUCTION</span>
              </div>
              <h3 style={{ fontFamily: "'Geist', sans-serif", fontSize: 28, fontWeight: 600, color: c.onSurface, marginBottom: 16 }}>{featured.title}</h3>
              <p style={{ fontFamily: "'Geist', sans-serif", fontSize: 16, color: c.onSurfaceVariant, lineHeight: 1.6, marginBottom: 24 }}>{featured.desc}</p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 32 }}>
                {featured.tags.map(t => (
                  <span key={t} style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, padding: "3px 8px", borderRadius: 4, background: c.surfaceVariant, color: c.primary }}>{t}</span>
                ))}
              </div>
              <div style={{ display: "flex", gap: 16 }}>
                <button style={{
                  padding: "12px 32px", borderRadius: 8, border: "none", cursor: "pointer",
                  background: c.primary, color: c.onPrimaryContainer,
                  fontFamily: "'JetBrains Mono', monospace", fontSize: 12, fontWeight: 700,
                  transition: "all 0.2s",
                }}>DEEPLINK_REPO</button>
                <button style={{
                  padding: "12px 16px", borderRadius: 8, cursor: "pointer",
                  background: "transparent",
                  border: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
                  color: c.onSurface, display: "flex", alignItems: "center", transition: "color 0.2s",
                }}>
                  <span className="material-symbols-outlined">share</span>
                </button>
              </div>
            </div>
          </div>
        </GlassCard>
      </div>
    </div>
  );
};